
import { SuscriptionDataType } from '@/api/SuscriptionsApi';
import { TenantDataType } from '@/api/TenantApi';
import { PlanFeatures } from '@/security/features.catalog';
import { DocumentLimits } from '@/security/documentLimits.catalog';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SuscriptionState {
    suscription?: SuscriptionDataType;
    tenantData?: TenantDataType;
    /** Features del plan (SuscriptionType) del tenant: undefined = no cargado, null = sin restricciones */
    planFeatures?: PlanFeatures;
    /** Topes mensuales de documentos del plan: undefined = no cargado, null = sin límites */
    planDocumentLimits?: DocumentLimits;
}

const initialState: SuscriptionState = {
};

const suscriptionSlice = createSlice({
    name: 'suscription',
    initialState,
    reducers: {
        setSuscriptionData(state, action: PayloadAction<SuscriptionDataType>) {
            state.suscription = action.payload
        },
        setTenantData(state, action: PayloadAction<TenantDataType>) {
            state.tenantData = action.payload
        },
        setPlanFeatures(state, action: PayloadAction<PlanFeatures>) {
            state.planFeatures = action.payload
        },
        setPlanDocumentLimits(state, action: PayloadAction<DocumentLimits>) {
            state.planDocumentLimits = action.payload
        },
        clearSuscriptionData(state) {
            state.suscription = {}
            state.tenantData = {}
            state.planFeatures = undefined
            state.planDocumentLimits = undefined
        },
    },
    extraReducers() {
    },
});

export const { setSuscriptionData, clearSuscriptionData, setTenantData, setPlanFeatures, setPlanDocumentLimits } = suscriptionSlice.actions;
export default suscriptionSlice.reducer;
